import React, { memo, useEffect } from 'react';
import { connect } from 'react-redux';

import './index.less';
import { bindActionCreators } from 'redux';
import { t } from '../../../languages';
import { loadRanking } from '../../../modules/user';
import Points from '../../Utils/Points';
import TopTen from './TopTen';

const UserRanking = ({ user, lang, loadRanking, ranking }) => {

    // console.log('UserRanking user:', user);

    useEffect(() => {
        loadRanking();

        return () => {
        }

    }, []);

    useEffect(() => {
        loadRanking();
    }, [user.points]);


    if (!user) {
        return null;
    } else {
        const points = user.points || 0;
        const position = ranking && ranking.mine ? ranking.mine.position : 0;
        const avatar = user.avatar || 0;

        const top10 = ranking && ranking.top10 ? ranking.top10 : [];
        const pos1 = top10 ? top10[0] : null;
        const pos2 = top10 ? top10[1] : null;
        const pos3 = top10 ? top10[2] : null;
        const top7 = top10.length > 3 ? top10.slice(3) : null;

        return <section className='user-ranking'>
            <section className='user-points'>
                <div className='avatar'>
                    {avatar ? <img src={`./static/avatar/${avatar ? avatar : 0}.jpg`} alt="" /> : null}
                </div>
                <div className='user-data'>
                    <h5>{user.name}</h5>
                    <ul>
                        <li><h6>{t(lang, 'yourpoints')}:</h6> <Points points={points} /></li>
                        <li><h6>{t(lang, 'yourposition')}:</h6> <span>{position}</span></li>
                    </ul>
                </div>
            </section>
            <TopTen lang={lang} top10={top10} />
        </section>;
    }
};

const mapStateToProps = ({ user }) => ({
    user: user.user,
    lang: user.lang,
    ranking: user.ranking,
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            loadRanking
        },
        dispatch
    );

export default memo(connect(mapStateToProps, mapDispatchToProps)(UserRanking));
